module.exports = __webpack_public_path__ + "img/02.af69217b.jpg";